var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53571 10.9286C3.21161 10.9286 2.93415 10.8132 2.70335 10.5824C2.47254 10.3516 2.35714 10.0742 2.35714 9.75007V1.89293C2.35714 1.56882 2.47254 1.29136 2.70335 1.06056C2.93415 0.829758 3.21161 0.714355 3.53571 0.714355H9.82143C10.1455 0.714355 10.423 0.829758 10.6538 1.06056C10.8846 1.29136 11 1.56882 11 1.89293V9.75007C11 10.0742 10.8846 10.3516 10.6538 10.5824C10.423 10.8132 10.1455 10.9286 9.82143 10.9286H3.53571ZM3.53571 9.75007H9.82143V1.89293H3.53571V9.75007ZM1.17857 13.2858C0.854464 13.2858 0.577009 13.1704 0.346205 12.9396C0.115402 12.7088 0 12.4313 0 12.1072V3.0715H1.17857V12.1072H8.64286V13.2858H1.17857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b6c3968c2f4d4d31836048f1bcad8114.svg";
export { ForwardRef as ReactComponent };